import React from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";

import "./footer.css";

const Footer = (props) => {
  return (
    <footer
      className={`footer-footer1 thq-section-padding ${props.rootClassName} `}>
      <div className="footer-max-width thq-section-max-width">
        <div className="footer-content">
          <div className="footer-newsletter">
            <img
              alt={props.logoAlt}
              src={props.logoSrc}
              className="footer-image1"
            />
            <span className="footer-content1 thq-body-small">
              Subscribe to our newsletter for the latest updates on new features
              and product releases.
            </span>
            <div className="footer-actions">
              <div className="footer-form">
                <div className="footer-container">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="footer-text-input thq-input"
                  />
                </div>
                <a
                  href="mailto:info@smcloudsolutions.com?subject=Subscribe"
                  className="footer-button thq-button-outline">
                  <span className="thq-body-small">{props.action1}</span>
                </a>
              </div>
              <span className="footer-content2 thq-body-small">
                {props.content2}
              </span>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-column1">
              <Link to="/" className="footer-navlink">
                <strong className="footer-column1-title thq-body-large">
                  {props.column1Title}
                </strong>
              </Link>
              <div className="footer-footer-links">
                <Link to="/about" className="footer-link1 thq-body-small">
                  {props.link1}
                </Link>
                <Link to="/legal" className="footer-link2 thq-body-small">
                  {props.link2}
                </Link>
                <span className="footer-link3 thq-body-small">
                  {props.link31}
                </span>
                <Link to="/contact-us" className="footer-link5 thq-body-small">
                  {props.link5}
                </Link>
              </div>
            </div>
            <div className="footer-column2">
              <Link to="/services" className="footer-navlink1">
                <strong className="footer-column2-title thq-body-large">
                  {props.column2Title}
                </strong>
              </Link>
              <div className="footer-footer-links1">
                <Link
                  to="/cloud-services"
                  className="footer-link6 thq-body-small">
                  {props.link6}
                </Link>
                <Link
                  to="/digital-marketing"
                  className="footer-link7 thq-body-small">
                  {props.link7}
                </Link>
                <Link
                  to="/web-development"
                  className="footer-link9 thq-body-small">
                  {props.link9}
                </Link>
                <Link to="/pricing" className="footer-link10 thq-body-small">
                  {props.link10}
                </Link>
              </div>
            </div>
            <div className="footer-column3">
              <strong className="thq-body-large footer-social-link1-title">
                {props.socialLinkTitleCategory}
              </strong>
              <div className="footer-social-links">
                <div className="footer-link">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small">
                    <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"></path>
                  </svg>
                  <span className="thq-body-small">
                    <a href="https://www.facebook.com/smcloudsolution">
                      Facebook
                    </a>
                  </span>
                </div>
                <div className="footer-link1">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="thq-icon-small">
                    <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                  </svg>
                  <span className="thq-body-small">
                    <a href="https://www.instagram.com/smcloudsolutions">
                      Instagram
                    </a>
                  </span>
                </div>
                <div className="footer-link2">
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="thq-icon-small">
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                  <span className="thq-body-small">X</span>
                </div>
                <div className="footer-link3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="thq-icon-small">
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M19.25 8.505c-1.577-5.867-7-5.5-7-5.5s-7.5-.5-7.5 8.995s7.5 8.996 7.5 8.996s4.458.296 6.5-3.918c.667-1.858.5-5.573-6-5.573c0 0-3 0-3 2.5c0 .976 1 2 2.5 2s3.171-1.027 3.5-3c1-6-4.5-6.5-6-4"
                      color="white"
                    />
                  </svg>
                  <span className="thq-body-small">
                    <a href="https://www.threads.com/@smcloudsolutions">
                      Threads
                    </a>
                  </span>
                </div>
                <div className="footer-link4">
                  <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                    <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                  </svg>
                  <span className="thq-body-small">Youtube</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer-row">
            <span className="thq-body-small">{props.content3}</span>
            <div className="footer-footer-links2">
              <span className="thq-body-small">{props.privacyLink}</span>
              <span className="thq-body-small">{props.termsLink}</span>
              <span className="thq-body-small">{props.cookiesLink}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  link2: "Legal Policy",
  link10: "Pricing",
  link7: "Digital Marketing",
  link1: "About Us",
  logoSrc: "/SM%20Cloud%20Logo%20Name%20Line.png",
  column2Title: "Services",
  action1: "Subscribe",
  content2: "Stay updated with our latest news and offers.",
  link9: "Web Development",
  termsLink: "Terms of Service",
  link5: "Contact Us",
  content3: "Ⓒ 2022 SM Cloud Solutions. All rights reserved.",
  link31: "Blog",
  link6: "Cloud Computing",
  privacyLink: "Privacy Policy",
  cookiesLink: "Cookie Policy",
  logoAlt: "Digital Marketing Company Logo",
  rootClassName: "",
  socialLinkTitleCategory: "Follow Us",
  column1Title: "SM Cloud",
};

Footer.propTypes = {
  link2: PropTypes.string,
  link10: PropTypes.string,
  link7: PropTypes.string,
  link1: PropTypes.string,
  logoSrc: PropTypes.string,
  column2Title: PropTypes.string,
  action1: PropTypes.string,
  content2: PropTypes.string,
  link9: PropTypes.string,
  termsLink: PropTypes.string,
  link5: PropTypes.string,
  content3: PropTypes.string,
  link31: PropTypes.string,
  link6: PropTypes.string,
  privacyLink: PropTypes.string,
  cookiesLink: PropTypes.string,
  logoAlt: PropTypes.string,
  rootClassName: PropTypes.string,
  socialLinkTitleCategory: PropTypes.string,
  column1Title: PropTypes.string,
};

export default Footer;
